export function getInitials(user) {
  const first = user?.first_name?.trim()?.[0];
  const last = user?.last_name?.trim()?.[0];
  if (first && last) return `${first}${last}`.toUpperCase();
  if (first) return first.toUpperCase();

  // Directory-synced users (Graph/Google) carry a single displayName
  // string instead of separate first_name/last_name.
  const nameParts = user?.displayName?.trim()?.split(/\s+/).filter(Boolean);
  if (nameParts?.length >= 2) return `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}`.toUpperCase();
  if (nameParts?.length === 1) return nameParts[0][0].toUpperCase();

  return user?.email?.[0]?.toUpperCase() || user?.Mail?.[0]?.toUpperCase() || user?.mail?.[0]?.toUpperCase() || '?';
}
